import {
    Component,
    EventEmitter,
    HostBinding,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { NgbActiveModal, NgbModalRef } from '@cmps/ng-bootstrap';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';

import { PersonOfInterestService } from '../../../../coaching-insight/oa/services/person-of-interest.service';
import { TranslationKeyMap } from '../fl-winning.i18n';
import {
    ColumnConfigItem,
    PersonOfInterest,
    TrendTypeByStyle,
} from '../model/fl-winning.global.model';
import { FLWinningPerson } from '../model/fl-winning.model';
import { FLWinningService } from '../services/fl-winning.service';
@Component({
    selector: '[frontlineWinningPersonRow]',
    templateUrl: './fl-winning-person-row.component.html',
    host: {
        class: 'team-floa-row',
    },
})
export class FLWinningPersonRowComponent implements OnInit {
    @Input() selectedUser: PersonOfInterest;
    @Input() active: string[];
    @Input() FLWinningPerson: FLWinningPerson;
    @Input() periodTypeId: number;
    @Input() periodTypeDate: Date;
    @Input() maxUncoached: number;
    @Input() maxCoached: number;

    @Output() metricsRendered: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    @Output() showingExpandMenu: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    @Output() selectedUserChange: EventEmitter<PersonOfInterest> =
        new EventEmitter<PersonOfInterest>();

    @Output() collapsed: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() receivedSubordinates: EventEmitter<FLWinningPerson[]> =
        new EventEmitter<FLWinningPerson[]>();

    @ViewChild('fractionHoverTpl', { static: true })
    fractionHoverTpl: TemplateRef<any>;

    @HostBinding('class.row-expanded')
    public get isRowExpanded(): boolean {
        return this.FLWinningPerson.isExpanded;
    }

    public columns: Observable<ColumnConfigItem[]>;

    /** @private */
    _i18n = TranslationKeyMap;

    loadingFlWinningTeam: boolean;

    public activetab = 'tab-performance';
    public activecolumns: Observable<number>;
    public _modal: NgbModalRef;
    /** private */ _trendTypeByStyle = TrendTypeByStyle;

    constructor(
        private readonly _flWinningService: FLWinningService,
        private readonly _personOfInterestService: PersonOfInterestService,
        public activeModal: NgbActiveModal,
    ) {
        this.loadingFlWinningTeam = false;
    }

    ngOnInit(): void {
        this.columns = this._flWinningService.flWinningColumns;
        this.columns.pipe(first()).subscribe();

        if (this.FLWinningPerson.isTop !== false) {
            this.getFlWinningPersonDR();
        }
    }

    getFlWinningPersonDR(): void {
        // if already expanded, collapse
        if (this.FLWinningPerson.isExpanded === true) {
            this.receivedSubordinates.emit(null);
            this.collapsed.emit(true);
            this.loadingFlWinningTeam = false;
            return;
        }
        if (this.FLWinningPerson.bottomRole === true) {
            this.openWP();
            return;
        }

        this.loadingFlWinningTeam = true;

        const p = this._flWinningService.retrieveTeamWinning(
            this.FLWinningPerson.userId,
            this._flWinningService.getDataRangeID(),
            this._flWinningService.getEvalRangeID(),
        );
        const f = p.subscribe(
            (team) => {
                f.unsubscribe();
                this.receivedSubordinates.emit(team);

                this.loadingFlWinningTeam = false;
            },
            () => {
                this.loadingFlWinningTeam = false;
            },
        );
    }

    openWP(): void {
        const user = {
            firstName: this.FLWinningPerson.userName,
            value: this.FLWinningPerson.userId.toString(),
            label: this.FLWinningPerson.userName,
            userId: this.FLWinningPerson.userId,
        };
        this._personOfInterestService.swapAndStoreFavourite(user);
        this._flWinningService.saveCurrentViewState();
        this.selectedUserChange.emit(user);
    }
}
